import { ACTION_STATUSES } from 'shared/consts';

export const isButtonLoading = (status: ACTION_STATUSES): boolean => {
  return status === ACTION_STATUSES.PENDING;
};
